import { useTranslation } from '../../i18n/LanguageContext';

// Status slugs are our own vocabulary, so they are translated here rather than
// rendered raw. An unmapped slug falls through to the value itself, as before.
const STATUS_KEYS = {
  active:        'status.active',
  available:     'machines.available',
  blocked:       'machines.blocked_one',
  shared:        'status.shared',
  transferred:   'status.transferred',
  archived:      'status.archived',
  pass:          'checks.pass',
  fail:          'checks.fail',
  issues:        'status.issues',
  valid:         'staff.stat_valid',
  expiring:      'staff.stat_expiring',
  expired:       'staff.stat_expired',
  minor:         'defects.sev_minor',
  moderate:      'defects.sev_moderate',
  major:         'defects.sev_major',
  critical:      'defects.sev_critical',
  emergency:     'status.emergency',
  open:          'defects.status_open',
  'in-progress': 'defects.status_in_progress',
  closed:        'status.closed',
  pending:       'dashboard.pending',
  resolved:      'defects.status_resolved',
  due:           'status.due',
  overdue:       'dashboard.overdue',
  done:          'common.done',
  draft:         'status.draft',
  sealed:        'service.sealed',
  approved:      'status.approved',
  declined:      'status.declined',
  scheduled:     'status.scheduled',
};

export default function StatusPill({ status, label, size = 'md' }) {
  const { t } = useTranslation();
  const styles = {
    // Machine status
    active:       { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
    available:    { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
    available:    { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
    blocked:      { bg: 'var(--color-danger-light)',  color: 'var(--color-danger)'  },
    shared:       { bg: '#E6F1FB',                    color: '#185FA5'              },
    transferred:  { bg: '#EEEDFE',                    color: '#534AB7'              },
    archived:     { bg: 'var(--color-bg-tertiary)',   color: 'var(--color-text-tertiary)' },

    // Check results
    pass:         { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
    fail:         { bg: 'var(--color-danger-light)',  color: 'var(--color-danger)'  },
    issues:       { bg: 'var(--color-warning-light)', color: 'var(--color-warning)' },

    // Qualification status
    valid:        { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
    expiring:     { bg: 'var(--color-warning-light)', color: 'var(--color-warning)' },
    expired:      { bg: 'var(--color-danger-light)',  color: 'var(--color-danger)'  },

    // Defect severity
    minor:        { bg: '#E6F1FB',                    color: '#185FA5'              },
    moderate:     { bg: 'var(--color-warning-light)', color: 'var(--color-warning)' },
    major:        { bg: 'var(--color-danger-light)',  color: 'var(--color-danger)'  },
    critical:     { bg: 'var(--color-danger)',        color: '#fff'                 },

    // Emergency
    emergency:    { bg: 'var(--color-danger)',        color: '#fff'                 },

    // General
    open:         { bg: 'var(--color-danger-light)',  color: 'var(--color-danger)'  },
    closed:       { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
    pending:      { bg: 'var(--color-warning-light)', color: 'var(--color-warning)' },
    resolved:     { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
    due:          { bg: 'var(--color-warning-light)', color: 'var(--color-warning)' },
    overdue:      { bg: 'var(--color-danger-light)',  color: 'var(--color-danger)'  },
    done:         { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
    draft:        { bg: 'var(--color-bg-tertiary)',   color: 'var(--color-text-tertiary)' },
    sealed:       { bg: '#E6F1FB',                    color: '#185FA5'              },
    approved:     { bg: 'var(--color-success-light)', color: 'var(--color-success)' },
    declined:     { bg: 'var(--color-danger-light)',  color: 'var(--color-danger)'  },
  };

  const s = styles[status?.toLowerCase()] || {
    bg: 'var(--color-bg-tertiary)',
    color: 'var(--color-text-tertiary)',
  };

  const sizes = {
    sm: { fontSize: 9,  padding: '1px 6px'  },
    md: { fontSize: 10, padding: '2px 8px'  },
    lg: { fontSize: 11, padding: '3px 10px' },
  };

  const sz = sizes[size] || sizes.md;

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      background: s.bg,
      color: s.color,
      borderRadius: 'var(--radius-full)',
      fontWeight: 'var(--font-weight-normal)',
      whiteSpace: 'nowrap',
      ...sz,
    }}>
      {label || (STATUS_KEYS[status?.toLowerCase()] ? t(STATUS_KEYS[status.toLowerCase()]) : status)}
    </span>
  );
}